export class UndoManager {
    _done: any | number[];
    _undone: any | number[];


    constructor() {
        var self = this;
        self._done = [];
        self._undone = [];
    }

    do(action) {
        var self = this;
        self._done.push(action);
        action.exec();

        for (var i = 0; i < self._undone.length; ++i) {
            var action = self._undone[i];
            action.destroy();
        }
        self._undone = [];
    }

    redo() {
        var self = this;
        if (self._undone.length === 0) {
            return;
        }
        var action = self._undone.pop();
        action.exec();
        self._done.push(action);
    }

    undo() {
        var self = this;
        if (self._done.length === 0) {
            return;
        }
        var action = self._done.pop();
        action.unexec();
        self._undone.push(action);
    }

}